import { Injectable } from '@angular/core';
import { ApiService, AppSettingsService } from '@woolworthsnz/styleguide';
import {
	AddressesSearchResponse,
	AreaResponse,
	LocationDetail,
	LocationDetailsRequest,
	LocationSearchRequest,
	LocationSearchResponse,
} from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { Division, SiteDetail, SiteLocation, StoreSearchResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class StoresService {
	constructor(private apiService: ApiService, private appSettingsService: AppSettingsService) {}

	getStoreInfo(id: number): Observable<SiteDetail[]> {
		return this.apiService.getDirect(
			`${this.appSettingsService.getSetting('siteLocationApiUrl')}${this.appSettingsService.getSetting(
				'storeSearchEndpointV2'
			)}/${id}`,
			{
				params: {
					division: [Division.countdown, Division.countdownPharmacy, Division.countdownLiquor],
				},
			}
		);
	}

	searchAddresses(query: string): Observable<AddressesSearchResponse> {
		return this.apiService.get(this.appSettingsService.getEndpoint('addresses'), {
			params: {
				query,
			},
		});
	}

	getAddressesDetails(id: string): Observable<AreaResponse> {
		return this.apiService.get(`${this.appSettingsService.getEndpoint('addresses')}/external-address`, {
			params: {
				addressId: id,
			},
		});
	}

	searchLocations(request: LocationSearchRequest): Observable<LocationSearchResponse> {
		return this.apiService.get(this.appSettingsService.getEndpoint('locations'), {
			params: {
				...request,
			},
		});
	}

	getLocationDetails(request: LocationDetailsRequest): Observable<LocationDetail> {
		return this.apiService.get(`${this.appSettingsService.getEndpoint('locations')}/details`, {
			params: request,
		});
	}

	searchStores(searchTerm: string): Observable<StoreSearchResponse> {
		return this.apiService.getDirect(
			`${this.appSettingsService.getSetting('siteLocationApiUrl')}${this.appSettingsService.getSetting(
				'storeSearchEndpoint'
			)}/search`,
			{
				params: {
					q: searchTerm,
				},
			}
		);
	}

	searchStoresDetailed(latitude: number, longitude: number, maxResults = 5): Observable<SiteLocation> {
		return this.apiService.getDirect(
			`${this.appSettingsService.getSetting('siteLocationApiUrl')}${this.appSettingsService.getSetting(
				'storeSearchEndpoint'
			)}`,
			{
				params: {
					latitude,
					longitude,
					maxResults,
				},
			}
		);
	}
}
